<template>
    <div
        class="cookie-policy pointer-events-none opacity-0 xl:backdrop-blur-sm fixed left-0 xl-max:bottom-0 xl:top-0 flex justify-center items-center
         xl:h-full w-full xl:bg-hh-grey-900/50 text-center z-100"
        :class="{ 'opacity-100 pointer-events-auto': active, 'opacity-0 pointer-events-none': ! active, 'h-full': expand }"
    >
        <div class="p-4 xl:p-8 max-w-xl bg-hh-grey-50 rounded-t xl:rounded-5xl shadow-center h-full xl:h-auto overflow-y-auto">

            <div class="py-1 xl:py-4 font-medium text-xl">{{ texts.popup.heading }}</div>

            <div v-if="! expand">
                <p class="" v-html="texts.popup['introduction-top']"></p>

                <div class="pt-2 xl:pt-4">
                    <button class="button clear mr-4" type="submit"  @click.prevent="expandPopup">
                        {{ texts.actions.modify }}
                    </button>
                    <button class="button cta" type="submit"  @click.prevent="acceptAll">
                        {{ texts.actions.accept }}
                    </button>
                </div>
            </div>

            <div v-else>
                <p v-html="texts.popup.introduction"></p>

                <div class="border rounded-3xl text-left">
                    <div class="flex border-b">
                        <div class="p-4 check flex items-center">
                            <div class="cookie-checkmark pre-checked "></div>
                        </div>
                        <div class="p-4">
                            <strong class="block">{{ texts.cookies.functional.name }}</strong>
                            {{ texts.cookies.functional.description }}
                        </div>
                    </div>

                    <div class="flex border-b">
                        <div class="p-4 check flex items-center">
                            <div class="cookie-checkmark pre-checked"></div>
                        </div>
                        <div class="p-4">
                            <strong class="block">{{ texts.cookies.analytical.name }}</strong>
                            {{ texts.cookies.analytical.description }}
                        </div>
                    </div>

                    <div class="flex border-0">
                        <div class="p-4 check flex items-center">
                            <div
                                data-ref="marketing"
                                class="cookie-checkmark checkable"
                                :class="{ checked: isMarketingChecked() }"
                                @click.prevent="toggle">
                            </div>
                        </div>
                        <div class="p-4">
                            <strong class="block">{{ texts.cookies.marketing.name }}</strong>
                            {{ texts.cookies.marketing.description }}
                        </div>
                    </div>
                </div>

                <div class="pt-8">
                    <button class="button orange !px-12 rounded" type="submit"  @click.prevent="setConsent">
                        {{ texts.actions.save }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {

        name: "CookiePolicy",

        props: ['texts', 'domain', 'show', 'setMarketingPreference'],

        data() {
            return {
                active: false,
                expand: false,
                checkedPreferences: {
                    'marketing': false,
                }
            }
        },

        mounted() {
            this.Bus.on('open-cookie-consent', (target) => {
               this.activatePopup();
            });

            if (this.setMarketingPreference) {
                this.checkedPreferences['marketing'] = true;
            }

            if (this.isSet) {
                this.expandPopup();
            }

            if (this.show === "1") {
                setTimeout(() => {
                    this.activatePopup();
                }, 1);
            }


        },

        methods: {
            toggle(event) {

                let target = event.target;
                let reference = target.getAttribute('data-ref');
                let checked = false;

                if (target.classList.contains('checked')) {
                    target.classList.remove('checked');
                } else {
                    target.classList.add('checked');
                    checked = true;
                }

                this.checkedPreferences[reference] = checked;
            },

            activatePopup() {
                this.active = true;

                // this.Bus.emit('set-popup-inactive-class');
            },

            expandPopup() {
                this.expand = true;
            },

            isMarketingChecked() {
                return this.isChecked('marketing');
            },

            isChecked(category) {
                return this.checkedPreferences[category] === true;
            },

            acceptAll() {
                this.checkedPreferences.marketing = true;

                this.setConsent();
            },


            setConsent() {
                const manager = window.cookiePolicyHandler;

                if (manager) {
                    // Link up the values
                    manager.checkedPreferences = this.checkedPreferences;
                    manager.deleteConsentCookie('hh_cookie_consent');//old cookie, no longer needed

                    manager.setConsentCookie(this.domain);
                }

                this.active = false;
            },


        }
    }
</script>
